module.exports = __webpack_public_path__ + "static/media/uz.a4884a96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/uz.svg
// module id = 280
// module chunks = 0